import React from 'react';
import GTMComponent from '../shared/Google/GTM';

const AppLayout = ({ children }) => {
  return (
    <>
      <GTMComponent />
      {children}
    </>
  );
};

export default AppLayout;